import { Injectable } from '@angular/core';
import { PilotPayHttpClient } from '../core';
import { Observable } from 'rxjs';
import { INotification } from './notifications.types';
import { IAuditLogEntry } from './components/audit-log/audit-log.types';

@Injectable()
export class NotificationsService {
	constructor(http: PilotPayHttpClient) {
		this.http = http;
	}

	private http: PilotPayHttpClient;

	public getNotificationsCount(): Observable<number> {
		return this.http.getRequest('/api/notifications/unread-count');
	}

	public getPagedNotifications(
		startIndex: number,
		endIndex: number,
		unreadOnly: boolean,
		filterText: string
	): Observable<INotification[]> {
		return this.http.getRequest(
			`/api/notifications/paged/${startIndex}/${endIndex}?unreadOnly=${unreadOnly}&query=${filterText}`
		);
	}

	markNotificationsRead(notificationIds: number[]): Observable<number> {
		return this.http.putRequest(`/api/notifications/mark-read`, { notificationIds: notificationIds });
	}

	markAllNotificationsRead(): Observable<number> {
		return this.http.putRequest(`/api/notifications/all-read`, null);
	}

	getTotalNotificationsCount(query: string): Observable<number> {
		return this.http.getRequest(`/api/notifications/count?query=${query}`);
	}

	getAuditLogData(importId: string): Observable<IAuditLogEntry> {
		return this.http.getRequest(`/api/notifications/${importId}`);
	}
}
